import { useState, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

//material ui
import {
  Grid,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Tooltip,
  Pagination,
  TablePagination,
  Fab,
  Stack,
  TextField,
  InputAdornment,
  Alert,
  Snackbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
  TextareaAutosize,
  FormControl,
  OutlinedInput,
  InputLabel,
  Autocomplete,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
//Icons
import PlaceIcon from "@mui/icons-material/Place";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PeopleIcon from "@mui/icons-material/People";
import SchoolSharpIcon from "@mui/icons-material/SchoolSharp";
import CurrencyRupeeSharpIcon from "@mui/icons-material/CurrencyRupeeSharp";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import ApprovalIcon from "@mui/icons-material/Approval";
import PrintIcon from "@mui/icons-material/Print";
import { useTheme } from "@mui/material/styles";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
//project components
import config from "../../../config";
import Job1 from "../../../assets/images/job1.png";

//third party
import axios from "axios";
import useAxiosAuth from "../../../hooks/useAxiosAuth";
import parse from "html-react-parser";
import JobPostForm from "../../admin/job-posts/JobPostForm";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import { Box } from "@mui/system";
import InterviewForm from "../../admin/job-posts/InterviewForm";
import {
  convertDateTimeToLocal,
  convertDateTimeToLocalReverse,
  convertDateToLocal,
  convertDateToLocalReverse,
} from "../../../utils/date-operations";
import { useFormik } from "formik";

import PrintComponent from "../../../ui-component/PrintComponent";
import InterviewLetterPrint from "./InterviewLetterPrint";
import { usePrintOperation } from "../../../context/PrintContext";
import { useReactToPrint } from "react-to-print";
import CustomTransliterateTextField from "../../../ui-component/CustomTransliterateTextField";

const JobPostDetails = () => {
  //Constants
  const navigate = useNavigate();
  const axiosAuth = useAxiosAuth();
  const { userId, userName, role, profileId, displayRole } = useSelector(
    (state) => state.userReducer,
  );

  const [searchParams, setSearchParams] = useSearchParams();
  const theme = useTheme();
  const { candidateFilterData } = useSelector((state) => state.generalReducer);
  const pageSize = 10000;
  const localRef = useRef(null);
  const { printStart, componentRef, printCmd } = usePrintOperation();

  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  //States
  // const [isPrint, setIsPrint] = useState(false);
  const [jobApplicationsLoading, setJobApplicationsLoading] = useState(false);
  const [selectedJobApplicationForPrint, setSelectedJobApplicationForPrint] =
    useState(null);
  const [jobPost, setJobPost] = useState();
  const [selectedApplication, setSelectedApplication] = useState();
  const [selectedInterview, setSelectedInterview] = useState({
    id: 0,
    jobPostId: 0,
    type: 1,
    description: "",
    dateTime: new Date(),
    venue: "",
    status: 0,
  });
  const [comments, setComments] = useState("");
  const [openInterViewForm, setOpenInterViewForm] = useState(false);
  const [openJobPostForm, setOpenJobPostForm] = useState(false);
  const [openAddApplicationConfirmation, setOpenAddApplicationConfirmation] =
    useState(false);
  const [
    openRemoveApplicationConfirmation,
    setOpenRemoveApplicationConfirmation,
  ] = useState(false);
  // const [openMarkPlacedConfirmation, setOpenMarkPlacedConfirmation] =
  //   useState(false);
  // const [openRemovePlacedConfirmation, setOpenRemovePlacedConfirmation] =
  //   useState(false);
  const [openStatusChangeConfirmation, setOpenStatusChangeConfirmation] =
    useState(false);
  const [newStatus, setNewStatus] = useState(null);
  const [
    openRemoveInterviewApplicationConfirmation,
    setOpenRemoveInterviewApplicationConfirmation,
  ] = useState(false);
  const [openInterviewDeleteConfirmation, setOpenInterviewDeleteConfirmation] =
    useState(false);
  const [openDeleteJobPostConfirmation, setOpenDeleteJobPostConfirmation] =
    useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState("Success");
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("Error");
  const [openAddApplicationDialog, setOpenAddApplicationDialog] =
    useState(false);
  const [candidates, setCandidates] = useState();
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [loadingCandidates, setLoadingCandidates] = useState(false);

  // const backFunction = () => {
  //   setOpenJobPostForm(true);
  //   navigate("/admin/jobposts");
  // };

  //Methods
  const getJobPost = () => {
    if (searchParams.get("ref") === null) {
      return;
    }
    setJobApplicationsLoading(true);
    let id = searchParams.get("ref");
    axiosAuth
      .get("/api/JobPosts/" + id)
      .then((response) => {
        setJobPost(response.data);
        setComments(response.data.comments);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setJobApplicationsLoading(false); // ⬅️ stop loading
      });
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSuccessOpen(false);
  };

  const handleErrorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setErrorOpen(false);
  };

  const formik = useFormik({
    initialValues: {
      candidateId: "",
      message: "",
    },
    onSubmit: (values) => {
      handleAddApplication(values);
    },
  });

  const getCandidates = (skip) => {
    let tempFilterData = {
      name: "",
      phoneNumber: "",
      location: "",
      gender: "",
      degreeName: "",
      minExperience: 0,
      maxExperience: 0,
      specialization: "",
      companyName: "",
      position: "",
      currentJobStatus: 0,
      registrationStatus: 0,
      skills: "",
      minSalary: 0,
      maxSalary: 0,
      isDeleted: false,
      isCandidateAvailable: true,
      amountDue: false,
      skip: 0,
      take: pageSize,
      filterApplied: false,
    };

    axiosAuth
      .post("/api/Candidates/list", tempFilterData)
      .then((response) => {
        setCandidates(response.data.candidates);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleAddApplication = async (values) => {
    try {
      const applicationData = {
        id: 0,
        jobPostId: jobPost.id,
        candidateId: values.candidateId,
        message: values.message,
      };

      const response = await axiosAuth.post(
        "/api/JobApplications",
        applicationData,
      );

      if (response.status === 200) {
        setSuccessMsg("Application added successfully!");
        setSuccessOpen(true);
        getJobPost();
        setOpenAddApplicationDialog(false);
        formik.resetForm();
        setSelectedCandidate(null);
      }
    } catch (error) {
      console.error("Error adding application:", error);
      setErrorMsg("Error adding application");
      setErrorOpen(true);
    }
  };

  const updatePlacementStatus = async (applicationId, placementStatus) => {
    try {
      await axiosAuth.put(
        `/api/JobApplications/update-placement-status?id=${applicationId}&placementStatus=${placementStatus}`,
      );
    } catch (error) {
      console.error("Error updating placement status:", error);
    }
  };

  const updateApplicationStatus = async (applicationId, status) => {
    try {
      const response = await axiosAuth.put(
        `/api/JobApplications/${applicationId}/${status}`,
      );

      if (response.status === 200) {
        if (status !== 4) {
          await updatePlacementStatus(applicationId, 0);
        }
        setSuccessMsg(
          `Status updated to ${
            status === 1
              ? "Applied"
              : status === 2
                ? "Selected for Interview"
                : "Placed"
          } successfully!`,
        );
        setSuccessOpen(true);
        getJobPost();
      }
    } catch (error) {
      console.error("Error updating status:", error);
      setErrorMsg("Error updating status");
      setErrorOpen(true);
    }
  };

  const handleStatusChangeClick = (application, status) => {
    setSelectedApplication(application);
    setNewStatus(status);
    setOpenStatusChangeConfirmation(true);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 0: // Applied
        return "grey.300";
      case 1: // Selected For Interview
        return "secondary.light";
      case 2: // Attended
        return "primary.light";
      case 3: // Not Attended
        return "warning.light";
      case 4: // Placed
        return "success.light";
      default:
        return "inherit";
    }
  };

  //UseEffect
  useEffect(() => {
    getJobPost();
    getCandidates();
  }, []);

  useEffect(() => {
    if (selectedJobApplicationForPrint) {
      reactToPrintFn();
    }
  }, [selectedJobApplicationForPrint]);

  return (
    <Grid maxWidth="xl" sx={{ marginX: "auto", paddingY: 4, paddingX: 2 }}>
      <Card elevation={3}>
        {jobPost != undefined ? (
          <Grid container spacing={3} sx={{ padding: 4 }}>
            <Grid item md={3} xs={12}>
              <Typography
                sx={{
                  fontWeight: "550",
                  fontSize: "1.4em",
                  color: "#001F6A",
                }}
              >
                {jobPost.employerName}
              </Typography>

              <Divider sx={{ marginY: 2 }} />
              <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                <PlaceIcon fontSize="small" color="primary" />
                <Typography sx={{ fontWeight: "600", color: "#757575" }}>
                  {jobPost.location}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                <BusinessCenterIcon fontSize="small" color="primary" />
                <Typography sx={{ fontWeight: "600", color: "#757575" }}>
                  {jobPost.jobTypeDisplay}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                <PeopleIcon fontSize="small" color="primary" />
                <Typography sx={{ fontWeight: "600", color: "#757575" }}>
                  {jobPost.noOfVaccancy} Vacancy
                </Typography>
              </Stack>

              <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                <SchoolSharpIcon fontSize="small" color="primary" />
                <Typography sx={{ fontWeight: "600", color: "#757575" }}>
                  {jobPost.qualification}
                </Typography>
              </Stack>

              <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                <CurrencyRupeeSharpIcon fontSize="small" color="primary" />
                <Typography sx={{ fontWeight: "600", color: "#757575" }}>
                  Salary : {jobPost.minSalary} - {jobPost.maxSalary} PM
                </Typography>
              </Stack>
              <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                <WorkHistoryIcon fontSize="small" color="primary" />
                {jobPost.maxExprienceRequired > 0 ? (
                  <Typography sx={{ fontWeight: "600", color: "#757575" }}>
                    Experience : {jobPost.minExprienceRequired} -{" "}
                    {jobPost.maxExprienceRequired} Years
                  </Typography>
                ) : (
                  <Typography sx={{ fontWeight: "600", color: "#757575" }}>
                    Freshers are allowed
                  </Typography>
                )}
              </Stack>

              <Divider sx={{ mb: 2 }} />
              <Stack direction="row" justifyContent="space-between">
                <Stack direction="row" spacing={1}>
                  <Tooltip title="Edit">
                    <Fab
                      size="small"
                      color="primary"
                      onClick={() => {
                        setOpenJobPostForm(true);
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </Fab>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <Fab
                      size="small"
                      color="error"
                      onClick={() => {
                        setOpenDeleteJobPostConfirmation(true);
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </Fab>
                  </Tooltip>

                  {jobPost.status === 1 ? (
                    <Tooltip title="Unpublish Job Post">
                      <Fab
                        size="small"
                        color="primary"
                        onClick={() => {
                          axiosAuth
                            .patch(
                              "/api/JobPosts/update-status?id=" +
                                jobPost.id +
                                "&status=2",
                            )
                            .then((response) => {
                              getJobPost();
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        }}
                      >
                        <CheckCircleIcon fontSize="small" />
                      </Fab>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Publish Job Post">
                      <Fab
                        size="small"
                        color="primary"
                        onClick={() => {
                          axiosAuth
                            .patch(
                              "/api/JobPosts/update-status?id=" +
                                jobPost.id +
                                "&status=1",
                            )
                            .then((response) => {
                              getJobPost();
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        }}
                      >
                        <UnpublishedIcon fontSize="small" />
                      </Fab>
                    </Tooltip>
                  )}
                </Stack>
                <Tooltip title="Go Back">
                  <Fab
                    size="small"
                    color="primary"
                    onClick={() => {
                      let prePage = searchParams.get("prePage");
                      navigate(prePage);
                    }}
                  >
                    <ArrowBackIcon fontSize="small" />
                  </Fab>
                </Tooltip>
              </Stack>
              <Divider sx={{ marginY: 2 }} />
              <FormControl fullWidth >
                <InputLabel id="other-status-label">Internal Status</InputLabel>
                <Select
                  labelId="other-status-label"
                  value={jobPost.otherStatus ?? 0}
                  label="Other Status"
                  onChange={(e) => {
                    const val = e.target.value;
                    axiosAuth
                      .patch(
                        `/api/JobPosts/update-other-status?id=${jobPost.id}&otherStatus=${val}`,
                      )
                      .then(() => getJobPost())
                      .catch((error) => {
                        console.log(error);
                        setErrorMsg("Error updating other status");
                        setErrorOpen(true);
                      });
                  }}
                >
                  <MenuItem value={0}>Select</MenuItem>
                  <MenuItem value={1}>Searching</MenuItem>
                  <MenuItem value={2}>Refine Search</MenuItem>
                  <MenuItem value={3}>Profile Sent</MenuItem>
                  <MenuItem value={4}>Int. Arranged</MenuItem>
                  <MenuItem value={5}>Int Result ?</MenuItem>
                  <MenuItem value={6}>Offer Sent</MenuItem>
                  <MenuItem value={7}>Joined</MenuItem>
                  <MenuItem value={8}>Not Joining</MenuItem>
                  <MenuItem value={9}>Closed by Co.</MenuItem>
                  <MenuItem value={10}>Job Left</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={9} xs={12}>
              <Typography
                sx={{
                  mb: 1,
                  fontWeight: "550",
                  fontSize: "1.4em",
                  color: "#001F6A",
                }}
              >
                {jobPost.title}
              </Typography>
              <Typography sx={{ color: "#757575" }}>
                {parse(jobPost.jobDescription)}
              </Typography>
              <Divider sx={{ marginY: 2 }} />
              {role === 1 && (
                <Stack direction="column" spacing={2}>
                  <Typography variant="h6">Comments</Typography>
                  {/* <TextField
                    fullWidth
                    variant="outlined"
                    multiline={true}
                    minRows={2}
                    value={comments}
                    onChange={(e) => {
                      setComments(e.target.value);
                    }}
                  /> */}
                  <CustomTransliterateTextField
                    id="comment"
                    name="comment"
                    value={comments}
                    onChangeText={(value) => {
                      setComments(value);
                    }}
                    lang="mr"
                    //label="Comments"
                    // isError={!!commentError}
                    // error={commentError}
                    multiline
                    rows={3}
                  />
                  <Button
                    variant="outlined"
                    sx={{
                      width: 150,
                      backgroundColor: theme.palette.secondary.light,
                    }}
                    onClick={() => {
                      axiosAuth
                        .patch(
                          `/api/JobPosts/update-comments?id=${jobPost.id}&comments=${comments}`,
                        )
                        .then((response) => {
                          if (response.status === 200) {
                            setSuccessMsg("Comments updates successfully!");
                            setSuccessOpen(true);
                          } else {
                            setErrorMsg("Error in updating comments.");
                            setErrorOpen(true);
                          }
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    }}
                  >
                    Save Comments
                  </Button>
                </Stack>
              )}
            </Grid>
          </Grid>
        ) : null}
        <Divider></Divider>
        <Grid sx={{ margin: 2 }}>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="h6">Job Applications Received</Typography>
            {role === 1 && (
              <Button
                variant="outlined"
                onClick={() => {
                  setOpenAddApplicationDialog(true);
                  getCandidates();
                }}
              >
                Apply Job
              </Button>
            )}
          </Stack>
          {jobApplicationsLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
              <Stack direction="column" alignItems="center" spacing={2}>
                <Typography variant="h6">Loading Applications...</Typography>
                <CircularProgress />
              </Stack>
            </Box>
          ) : jobPost?.jobApplications?.length > 0 ? (
            <>
              {jobPost?.jobApplications.map((application, index) => {
                return (
                  <Card
                    key={index}
                    variant="outlined"
                    sx={{
                      padding: 1,
                      marginTop: 1,
                      display: "flex",
                      direction: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: getStatusColor(application.status),
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                          display: "flex",
                          direction: "row",
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <Typography sx={{ marginRight: 2 }}>
                          {index + 1}.
                        </Typography>
                        <Link
                          to={"/profile?ref=" + application.candidateId}
                          underline="hover"
                        >
                          {application.candidateName}
                        </Link>
                        <Typography sx={{ marginLeft: 2 }}>
                          ({application.candidatePhoneNo})
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                          display: "flex",
                          direction: "row",
                          justifyContent: "end",
                          alignItems: "center",
                        }}
                      >
                        <Tooltip title="Select For Interview">
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              setSelectedApplication(application);
                              setOpenAddApplicationConfirmation(true);
                            }}
                          >
                            <PlaylistAddCheckIcon />
                          </Button>
                        </Tooltip>
                        <Tooltip title="Remove Application">
                          <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => {
                              setSelectedApplication(application);
                              setOpenRemoveApplicationConfirmation(true);
                            }}
                            sx={{ marginLeft: 2 }}
                          >
                            <CloseIcon />
                          </Button>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Card>
                );
              })}
            </>
          ) : (
            <Card
              variant="outlined"
              sx={{
                padding: 4,
                marginY: 2,
                backgroundColor: theme.palette.grey[200],
              }}
            >
              <Typography textAlign="center">
                There are no applications received for this job post.
              </Typography>
            </Card>
          )}
          <Divider />
        </Grid>
        {jobPost?.jobApplications.length > 0 && (
          <Grid sx={{ margin: 2 }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ marginBottom: 2 }}
            >
              <Typography variant="h6">Interviews</Typography>
              <Button
                variant="outlined"
                onClick={() => {
                  setSelectedInterview({
                    // id: 0,
                    // jobPostId: jobPost.id,
                    // description: "",
                    // dateTime: new Date().toISOString().split("T")[0],
                    // venue: "",
                    // status: 0,
                    id: 0,
                    jobPostId: jobPost.id,
                    type: 1,
                    description: "",
                    dateTime: convertDateTimeToLocalReverse(new Date()),
                    venue: "",
                    status: 0,
                  });
                  setOpenInterViewForm(true);
                }}
              >
                Add New Interview
              </Button>
            </Stack>
            {jobPost?.interviews.map((interview, index) => {
              return (
                <Accordion
                  key={index}
                  sx={{ backgroundColor: theme.palette.grey[200] }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography sx={{ fontWeight: 500 }} color="primary.main">
                      Interview {index + 1}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Divider sx={{ marginBottom: 2 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Stack direction="row" alignItems="center" spacing={3}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Interview Date:
                          </Typography>
                          <Typography>
                            {convertDateTimeToLocal(interview.dateTime)}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Stack direction="row" alignItems="center" spacing={3}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Venue:
                          </Typography>
                          <Typography>{interview.venue}</Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Stack direction="row" alignItems="center" spacing={3}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Interview Type:
                          </Typography>
                          <Typography>{interview.typeDisplay}</Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography sx={{ fontWeight: 600 }}>
                          Description:
                        </Typography>
                        <Typography color="primary.main">
                          {interview.description}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Divider sx={{ marginY: 2 }} />
                    <Typography sx={{ fontWeight: 600 }}>
                      Selected Applications for Interview.
                    </Typography>
                    <Stack direction="row">
                      <Grid container spacing={2} sx={{ marginTop: 1 }}>
                        {interview.jobApplicationInterviews?.map(
                          (application, index) => {
                            console.log("application", application);
                            return (
                              <Grid item xs={12} lg={6} key={index}>
                                <Card
                                  sx={{
                                    padding: 2,
                                    marginRight: 2,
                                    backgroundColor: getStatusColor(
                                      application.jobApplication.status,
                                    ),
                                  }}
                                  variant="outlined"
                                >
                                  <Grid container spacing={2}>
                                    {/* Left side - Candidate information */}
                                    <Grid item xs={12} sm={6}>
                                      <Typography variant="h5">
                                        {
                                          application.jobApplication
                                            .candidateName
                                        }
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      display="flex"
                                      justifyContent="flex-end"
                                    >
                                      <Stack direction="row" spacing={2}>
                                        <Tooltip title="Print Interview Letter">
                                          <Button
                                            sx={{ mr: 2 }}
                                            variant="outlined"
                                            onClick={() => {
                                              setSelectedJobApplicationForPrint(
                                                application.jobApplication,
                                              );
                                              reactToPrintFn();
                                            }}
                                          >
                                            <PrintIcon />
                                          </Button>
                                        </Tooltip>
                                        <InterviewLetterPrint
                                          ref={contentRef}
                                          jobPost={jobPost}
                                          candidates={candidates}
                                          selectedJobApplicationId={
                                            selectedJobApplicationForPrint?.id
                                          }
                                        />
                                        <Tooltip title="Remove Application">
                                          <Button
                                            variant="outlined"
                                            size="medium"
                                            color="error"
                                            onClick={() => {
                                              setSelectedApplication(
                                                application,
                                              );
                                              setOpenRemoveInterviewApplicationConfirmation(
                                                true,
                                              );
                                            }}
                                          >
                                            <CloseIcon />
                                          </Button>
                                        </Tooltip>
                                      </Stack>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        Mobile No.
                                      </Typography>
                                      <Typography variant="h6">
                                        {application.jobApplication
                                          .candidatePhoneNo || "--"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        Email Address:
                                      </Typography>
                                      <Typography variant="h6">
                                        {application.jobApplication
                                          .candidateEmail || "--"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <FormControl
                                        size="small"
                                        sx={{ mt: 2, minWidth: 200 }}
                                      >
                                        <InputLabel id="application-status-label">
                                          Application Status
                                        </InputLabel>
                                        <Select
                                          labelId="application-status-label"
                                          id="application-status"
                                          value={
                                            application.jobApplication.status
                                          }
                                          label="Application Status"
                                          onChange={(e) => {
                                            const newStatus = e.target.value;
                                            setSelectedApplication(
                                              application.jobApplication,
                                            );
                                            handleStatusChangeClick(
                                              application.jobApplication,
                                              newStatus,
                                            );
                                          }}
                                        >
                                          <MenuItem value={0}>Applied</MenuItem>
                                          <MenuItem value={1}>
                                            Selected for Interview
                                          </MenuItem>
                                          <MenuItem value={2}>
                                            Attended
                                          </MenuItem>
                                          <MenuItem value={3}>
                                            Not Attended
                                          </MenuItem>
                                          <MenuItem value={4}>Placed</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    {application.jobApplication.status ===
                                      4 && (
                                      <Grid item xs={12} sm={6}>
                                        <FormControl
                                          size="small"
                                          sx={{ mt: 2, minWidth: 200 }}
                                        >
                                          <InputLabel id="placement-status-label">
                                            Placement Status
                                          </InputLabel>
                                          <Select
                                            labelId="placement-status-label"
                                            value={
                                              jobPost.jobApplications.find(
                                                (a) =>
                                                  a.id ===
                                                  application.jobApplication.id,
                                              )?.placementStatus ?? 0
                                            }
                                            label="Placement Status"
                                            onChange={(e) => {
                                              updatePlacementStatus(
                                                application.jobApplication.id,
                                                e.target.value,
                                              ).then(() => getJobPost());
                                            }}
                                          >
                                            <MenuItem value={0}>
                                              Unknown
                                            </MenuItem>
                                            <MenuItem value={1}>
                                              Offer Accepted
                                            </MenuItem>
                                            <MenuItem value={2}>
                                              Joined
                                            </MenuItem>
                                            <MenuItem value={3}>
                                              Not Joined
                                            </MenuItem>
                                            <MenuItem value={4}>
                                              Job Left
                                            </MenuItem>
                                            <MenuItem value={5}>
                                              Invoice Sent
                                            </MenuItem>
                                            <MenuItem value={6}>
                                              Amount Received
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Card>
                              </Grid>
                            );
                          },
                        )}
                      </Grid>
                    </Stack>
                  </AccordionDetails>
                  <AccordionActions>
                    <Button
                      onClick={() => {
                        setSelectedInterview({
                          id: interview.id,
                          jobPostId: interview.jobPostId,
                          description: interview.description,
                          dateTime: convertDateTimeToLocalReverse(
                            interview.dateTime,
                          ),
                          venue: interview.venue,
                          // venue: interview.venue,
                          type: interview.type,
                          status: 0,
                        });
                        setOpenInterViewForm(true);
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      color="error"
                      onClick={() => {
                        if (interview.jobApplicationInterviews?.length > 0) {
                          alert(
                            "Cannot delete the interview as it has applications. Remove all applications first.",
                          );
                        } else {
                          setSelectedInterview({
                            id: interview.id,
                            jobPostId: interview.jobPostId,
                            description: interview.description,
                            dateTime: convertDateToLocalReverse(
                              interview.dateTime,
                            ),
                            venue: interview.venue,
                            type: interview.type,
                            status: 0,
                          });
                          setOpenInterviewDeleteConfirmation(true);
                        }
                      }}
                    >
                      Delete
                    </Button>
                  </AccordionActions>
                </Accordion>
              );
            })}
          </Grid>
        )}
      </Card>
      {/* {printCmd && ( */}
      {/* <InterviewLetterPrint
        ref={contentRef}
        jobPost={jobPost}
        candidates={candidates}
        selectedJobApplicationId={selectedJobApplicationForPrint?.id}
      /> */}
      {/* // )} */}
      {/* jobpost form dialog */}
      <Dialog
        fullWidth
        maxWidth="xl"
        open={openJobPostForm}
        onClose={() => {
          setOpenJobPostForm(false);
        }}
      >
        <DialogContent>
          <JobPostForm
            jobPost={jobPost}
            onSave={() => {
              getJobPost();
              setOpenJobPostForm(false);
            }}
            onCancel={() => {
              setOpenJobPostForm(false);
            }}
          />
        </DialogContent>
      </Dialog>
      {/* interview form dialog */}
      <Dialog
        fullWidth
        maxWidth="md"
        open={openInterViewForm}
        onClose={() => {
          setOpenInterViewForm(false);
        }}
      >
        <DialogContent>
          <InterviewForm
            interview={selectedInterview}
            onSave={() => {
              getJobPost();
              setOpenInterViewForm(false);
            }}
            onCancel={() => {
              setOpenInterViewForm(false);
            }}
          />
        </DialogContent>
      </Dialog>
      {/* Add application to interview confirmation dialog */}
      <Dialog
        fullWidth
        open={openAddApplicationConfirmation}
        keepMounted
        onClose={() => {
          setOpenAddApplicationConfirmation(false);
        }}
      >
        <DialogTitle>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">
              Add Below Job Application To The Interview
            </Typography>
            <IconButton
              onClick={() => {
                setOpenAddApplicationConfirmation(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          Candidate:
          <Typography sx={{ fontWeight: 500 }} color="secondary.dark">
            {selectedApplication?.candidateName}
          </Typography>
          {jobPost?.interviews.length > 0 ? (
            <>
              {jobPost?.interviews.map((interview, index) => {
                return (
                  <Button
                    variant="outlined"
                    key={index}
                    fullWidth
                    sx={{ marginTop: 2 }}
                    onClick={() => {
                      axiosAuth
                        .post("/api/JobApplicationInterview", {
                          id: 0,
                          jobApplicationId: selectedApplication?.id,
                          interviewId: interview.id,
                        })
                        .then((response) => {
                          if (response.status === 200) {
                            axiosAuth
                              .put(
                                "/api/JobApplications/" +
                                  selectedApplication.id +
                                  "/1",
                              )
                              .then((response) => {
                                if (response.status === 200) {
                                  setSuccessMsg(
                                    "Application selected for interview successfully!",
                                  );
                                  setSuccessOpen(true);
                                  getJobPost();
                                }
                              })
                              .catch((error) => {
                                console.log(error);
                                setErrorMsg(
                                  "Failed to update application status",
                                );
                                setErrorOpen(true);
                              });
                          }
                        })
                        .catch((error) => {
                          console.log(error);
                          if (
                            error.response &&
                            error.response?.status === 400
                          ) {
                            setErrorMsg(
                              "Interview already scheduled for this application",
                            );
                          } else {
                            setErrorMsg("Failed to schedule interview");
                          }
                          setErrorOpen(true);
                        });
                      setOpenAddApplicationConfirmation(false);
                    }}
                  >
                    Interview {index + 1}
                  </Button>
                );
              })}
            </>
          ) : (
            <Typography sx={{ marginY: 3 }}>
              There are no interviews scheduled. Please add at least one
              interview
            </Typography>
          )}
        </DialogContent>
      </Dialog>
      {/* Remove application from job post dialog */}
      <Dialog
        open={openRemoveApplicationConfirmation}
        keepMounted
        onClose={() => {
          setOpenRemoveApplicationConfirmation(false);
        }}
      >
        <DialogTitle>{"Remove application"}</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to remove{" "}
            <b>
              {selectedApplication?.candidateName}
              's
            </b>{" "}
            application from the job post?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              axiosAuth
                .delete("/api/JobApplications/" + selectedApplication?.id)
                .then((response) => {
                  if (response.status === 200) {
                    setSuccessMsg(
                      "Application successfully removed from the job post!",
                    );
                    setSuccessOpen(true);
                    getJobPost();
                  }
                })
                .catch((error) => {
                  console.log(error);
                  setErrorOpen(true);
                });
              setOpenRemoveApplicationConfirmation(false);
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenRemoveApplicationConfirmation(false);
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      {/* Remove application from interview dialog */}
      <Dialog
        open={openRemoveInterviewApplicationConfirmation}
        keepMounted
        onClose={() => {
          setOpenRemoveInterviewApplicationConfirmation(false);
        }}
      >
        <DialogTitle>{"Remove application"}</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to remove{" "}
            <b>
              {selectedApplication?.jobApplication?.candidateName}
              's
            </b>{" "}
            application from the interview?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              axiosAuth
                .delete(
                  "/api/JobApplicationInterview/" + selectedApplication.id,
                )
                .then((response) => {
                  if (response.status === 200) {
                    setSuccessMsg(
                      "Successfully removed application from the interview",
                    );
                    setSuccessOpen(true);
                    getJobPost();
                  }
                })
                .catch((error) => {
                  console.log(error);
                  setErrorOpen(true);
                });
              setOpenRemoveInterviewApplicationConfirmation(false);
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenRemoveInterviewApplicationConfirmation(false);
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      {/* Mark as placed confirmation dialog */}
      {/* <Dialog
        open={openMarkPlacedConfirmation}
        keepMounted
        onClose={() => {
          setOpenMarkPlacedConfirmation(false);
        }}
      >
        <DialogTitle>{"Mark as Placed"}</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to mark{" "}
            <b>{selectedApplication?.jobApplication?.candidateName}</b> as
            placed for this job post?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              axiosAuth
                .put("/api/JobApplications/" + selectedApplication?.id + "/2")
                .then((response) => {
                  if (response.status === 200) {
                    getJobPost();
                    setSuccessMsg(
                      "Job application successfully marked as placed!"
                    );
                    setSuccessOpen(true);
                  }
                })
                .catch((error) => {
                  console.log(error);
                  setErrorOpen(true);
                });
              setOpenMarkPlacedConfirmation(false);
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenMarkPlacedConfirmation(false);
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog> */}
      {/* Mark as placed confirmation dialog */}{" "}
      {/* <Dialog
        open={openMarkPlacedConfirmation}
        keepMounted
        onClose={() => {
          setOpenMarkPlacedConfirmation(false);
        }}
      >
        <DialogTitle>{"Mark as Placed"}</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to mark{" "}
            <b>{selectedApplication?.candidateName}</b> as placed for this job
            post?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              updateApplicationStatus(selectedApplication?.id, 3);
              setOpenMarkPlacedConfirmation(false);
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenMarkPlacedConfirmation(false);
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog> */}
      {/* Remove placed confirmation dialog */}
      {/* <Dialog
        open={openRemovePlacedConfirmation}
        keepMounted
        onClose={() => {
          setOpenRemovePlacedConfirmation(false);
        }}
      >
        <DialogTitle>{"Remove placed status"}</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to remove placed status for{" "}
            <b>{selectedApplication?.jobApplication?.candidateName}</b> from
            this job post?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              axiosAuth
                .put("/api/JobApplications/" + selectedApplication?.id + "/1")
                .then((response) => {
                  if (response.status === 200) {
                    getJobPost();
                    setSuccessMsg("Successfully removed placed status!");
                    setSuccessOpen(true);
                  }
                })
                .catch((error) => {
                  console.log(error);
                  setErrorOpen(true);
                });
              setOpenRemovePlacedConfirmation(false);
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenRemovePlacedConfirmation(false);
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog> */}
      <Dialog
        open={openStatusChangeConfirmation}
        keepMounted
        onClose={() => setOpenStatusChangeConfirmation(false)}
      >
        <DialogTitle>
          {`Confirm Status Change to ${
            newStatus === 1
              ? "Applied"
              : newStatus === 2
                ? "Selected for Interview"
                : "Placed"
          }`}
        </DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to change the status of{" "}
            <b>{selectedApplication?.candidateName}</b> to{" "}
            {newStatus === 1
              ? "Applied"
              : newStatus === 2
                ? "Selected for Interview"
                : "Placed"}
            ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              updateApplicationStatus(selectedApplication?.id, newStatus);
              setOpenStatusChangeConfirmation(false);
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={() => setOpenStatusChangeConfirmation(false)}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete interview confirmation dialog */}
      <Dialog
        open={openInterviewDeleteConfirmation}
        keepMounted
        onClose={() => {
          setOpenInterviewDeleteConfirmation(false);
        }}
      >
        <DialogTitle>{"Delete Interview"}</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the selected interview?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              axiosAuth
                .delete("/api/Interviewes/" + selectedInterview?.id)
                .then((response) => {
                  if (response.status === 200) {
                    getJobPost();
                    setSuccessMsg("Successfully deleted interview!");
                    setSuccessOpen(true);
                  }
                })
                .catch((error) => {
                  console.log(error);
                  setErrorOpen(true);
                });
              setOpenInterviewDeleteConfirmation(false);
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenInterviewDeleteConfirmation(false);
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete job post confirmation dialog */}
      <Dialog
        open={openDeleteJobPostConfirmation}
        keepMounted
        onClose={() => {
          setOpenDeleteJobPostConfirmation(false);
        }}
      >
        <DialogTitle>{"Delete Job Post"}</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this job post "{jobPost?.title}"?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              axiosAuth
                .delete("/api/JobPosts/" + jobPost?.id)
                .then((response) => {
                  if (response.status === 200) {
                    setSuccessMsg("Job post successfully deleted!");
                    setSuccessOpen(true);
                    // Navigate back to job posts page
                    let prePage = searchParams.get("prePage");
                    navigate(prePage || "/admin/jobposts");
                  }
                })
                .catch((error) => {
                  console.log(error);
                  setErrorMsg("Error deleting job post.");
                  setErrorOpen(true);
                });
              setOpenDeleteJobPostConfirmation(false);
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenDeleteJobPostConfirmation(false);
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      {/* Apply Job Dialog */}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openAddApplicationDialog}
        onClose={() => {
          setOpenAddApplicationDialog(false);
          formik.resetForm();
          setSelectedCandidate(null);
        }}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle>
          <Stack direction="row" alignItems="center" spacing={1}>
            <ApprovalIcon color="primary" />
            <Typography variant="h6" color="primary">
              Apply Job
            </Typography>
          </Stack>
        </DialogTitle>
        <Divider sx={{ mx: 2 }} />
        <form onSubmit={formik.handleSubmit}>
          <DialogContent sx={{ pt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  options={candidates}
                  getOptionLabel={(option) =>
                    `${option.salutation} ${option.firstName} ${option.middleName} ${option.lastName}`
                  }
                  loading={loadingCandidates}
                  onOpen={() => getCandidates()}
                  disabled={
                    loadingCandidates || !candidates || candidates.length === 0
                  }
                  onInputChange={(event, newInputValue) => {
                    getCandidates(newInputValue);
                  }}
                  onChange={(event, newValue) => {
                    setSelectedCandidate(newValue);
                    formik.setFieldValue("candidateId", newValue?.id || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        !candidates
                          ? "Loading Candidates..."
                          : "Search Candidate"
                      }
                      variant="outlined"
                      fullWidth
                      required
                      size="small"
                    />
                  )}
                />
              </Grid>

              {selectedCandidate && (
                <>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography variant="body2" color="text.secondary">
                        Mobile Number:
                      </Typography>
                      <Typography variant="subtitle1" fontWeight={500}>
                        {selectedCandidate?.phoneNumber || "--"}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography variant="body2" color="text.secondary">
                        Email Address:
                      </Typography>
                      <Typography variant="subtitle1" fontWeight={500}>
                        {selectedCandidate?.email || "--"}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack spacing={0.5}>
                      <Typography variant="body2" color="text.secondary">
                        City:
                      </Typography>
                      <Typography variant="subtitle1" fontWeight={500}>
                        {selectedCandidate?.city || "--"}
                      </Typography>
                    </Stack>
                  </Grid>
                </>
              )}

              <Grid item xs={12}>
                <TextField
                  label="Message (Optional)"
                  name="message"
                  value={formik.values.message}
                  onChange={formik.handleChange}
                  multiline
                  rows={3}
                  fullWidth
                  size="small"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <Divider sx={{ mx: 2, mb: 2 }} />
          <DialogActions
            sx={{
              px: 3,
              pb: 3,
              justifyContent: "flex-start",
              flexDirection: "row",
              gap: 2,
            }}
          >
            <Button
              type="submit"
              variant="contained"
              disabled={!selectedCandidate}
              sx={{ minWidth: 100 }}
            >
              Apply
            </Button>
            <Button
              onClick={() => {
                setOpenAddApplicationDialog(false);
                formik.resetForm();
                setSelectedCandidate(null);
              }}
              variant="outlined"
              sx={{ minWidth: 100 }}
            >
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Snackbar
        open={successOpen}
        autoHideDuration={6000}
        onClose={handleSuccessClose}
      >
        <Alert
          onClose={handleSuccessClose}
          severity="success"
          sx={{
            width: "100%",
            backgroundColor: "#009933",
            color: theme.palette.white.main,
          }}
          variant="filled"
        >
          {successMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={errorOpen}
        autoHideDuration={6000}
        onClose={handleErrorClose}
      >
        <Alert
          onClose={handleErrorClose}
          severity="error"
          sx={{ width: "100%" }}
          variant="filled"
        >
          {errorMsg}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default JobPostDetails;
